import React, { ChangeEvent, FC, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { Edit } from '../../constructor/work/Edit';

interface Props {
  isOpen: boolean;
  closeModal(): void;
}

export const ChangeHeightModal: FC<Props> = ({ closeModal, isOpen }) => {
  const [heightPoints, setHeightPoints] = useState(Edit.totalPointHeight * 1000);

  const onButtonClick = () => {
    if (Edit.sectionsObjects) {
      Edit.changeTotalPointHeight(heightPoints / 1000);
    }
    closeModal();
  };
  const onChangeText = (evt: ChangeEvent<HTMLInputElement>) => {
    const _text = evt.target.value.replace(/[^0-9]/g, '');
    setHeightPoints(+_text);
  };

  return (
    <CustomModal title="Масштаб" handleClose={closeModal} open={isOpen}>
      <Stack flexGrow={1} spacing={2} pt={3} pl={5} pr={5}>
        <Box
          width="100%"
          mb={2}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <TextField
            autoComplete="off"
            value={heightPoints}
            label="Высота всех точек, мм"
            fullWidth
            size="small"
            onChange={onChangeText}
          />
        </Box>

        <Button variant="contained" size="large" onClick={onButtonClick}>
          <Typography fontSize="16px" color="white">
            Задать высоту
          </Typography>
        </Button>
      </Stack>
    </CustomModal>
  );
};
